import { bookingAppointmentTypeActions, IBookingAppointmentType } from "../../../state/booking-appointment-type";
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { CreateBookingType } from "../../../config/params";

export const useBookingAppointmentTypeStore = () => {
  const dispatch = useDispatch();
  const { bookingAppointmentType, appointmentTypeIndicator, isDropoffAvailable, isServiceStatusUpdated } =
  useSelector((state: IRootState) => state.bookingAppointmentType as IBookingAppointmentType);

  const setBookingAppointmentType = (bookingType: CreateBookingType) => {
    dispatch(bookingAppointmentTypeActions.setBookingAppointmentType(bookingType));
  };

  const setDefaultBookingType = () => {
    dispatch(bookingAppointmentTypeActions.setDefaultBookingType());
  };

  const setAppointmentTypeIndicator = (appointmentType: Number) => {
    dispatch(bookingAppointmentTypeActions.setAppointmentTypeIndicator(appointmentType));
  };

  const setIsDropoffAvailable = (isAvailable: Boolean) => {
    dispatch(bookingAppointmentTypeActions.setIsDropoffAvailable(isAvailable));
  };

  const setIsServiceStatusUpdated = (isStatusUpdated: Boolean) => {
    dispatch(bookingAppointmentTypeActions.setIsServiceStatusUpdated(isStatusUpdated));
  };

  return {
    setBookingAppointmentType,
    setAppointmentTypeIndicator,
    setDefaultBookingType,
    setIsDropoffAvailable,
    setIsServiceStatusUpdated,
    bookingAppointmentType,
    appointmentTypeIndicator,
    isDropoffAvailable,
    isServiceStatusUpdated,
  };
};

export default useBookingAppointmentTypeStore;


